<div class="file-management-container">
  <div class="header">
    <button mat-raised-button 
          color="primary" 
          class="dashboard-button" 
          routerLink="/home">
    <mat-icon>dashboard</mat-icon>
    <span>Home</span>
    </button>
    <h1 class="page-title" >File Management</h1>
</div>

  <!-- Breadcrumb Navigation -->
  <div class="breadcrumb">
    <span class="breadcrumb-item" (click)="navigateToPath(-1)">General</span>
    <ng-container *ngFor="let segment of pathSegments; let i = index">
      <span class="separator">/</span>
      <span class="breadcrumb-item" (click)="navigateToPath(i)">{{segment}}</span>
    </ng-container>
  </div>

  <!-- Error Message -->
  <div class="error-message" *ngIf="error">
    {{ error }}
  </div>

  <!-- Create Directory Section -->
  <div class="create-directory-section">
    <input type="text" 
           [(ngModel)]="newDirectoryName" 
           placeholder="New directory name"
           [disabled]="uploading">
    <button (click)="createDirectory()" 
            [disabled]="!newDirectoryName || uploading">
      <i class="fas fa-folder-plus"></i> Create Directory
    </button>
  </div>

  <!-- Upload Section -->
  <div class="upload-section">
    <input type="file" 
           #fileInput
           (change)="onFileSelected($event)"
           [multiple]="true"
           [disabled]="uploading"
           style="display: none">
    
    <button class="upload-btn" 
            (click)="fileInput.click()"
            [disabled]="uploading">
      <i class="fas fa-upload"></i>
      {{ uploading ? 'Uploading...' : 'Upload Files' }}
    </button>
  </div>

  <!-- Loading Spinner -->
  <div class="loading-spinner" *ngIf="loading">
    <i class="fas fa-spinner fa-spin"></i> Loading...
  </div>

  <!-- Content Section -->
  <div class="content-section" *ngIf="!loading">
    <!-- Directories -->
    <div class="directories-section" *ngIf="directories.length > 0">
      <h3>Directories</h3>
      <div class="directories-grid">
        <div class="directory-item" 
             *ngFor="let dir of directories"
             (click)="navigateToDirectory(dir)">
          <i class="fas fa-folder"></i>
          <span class="name">{{ dir.name }}</span>
          <span class="details">
            Created: {{ formatDate(dir.created) }}
          </span>
        </div>
      </div>
    </div>

    <!-- Files -->
    <div class="files-section" *ngIf="files.length > 0">
      <h3>Files</h3>
      <table class="files-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Size</th>
            <th>Created</th>
            <th>Modified</th>
            <th>Import Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let file of files">
            <td>{{ file.name }}</td>
            <td>{{ formatFileSize(file.size) }}</td>
            <td>{{ formatDate(file.created) }}</td>
            <td>{{ formatDate(file.lastModified) }}</td>
            <td>
              <span class="status" [class.imported]="file.imported">
                {{ file.imported ? 'Imported' : 'Not Imported' }}
              </span>
            </td>
            <td class="actions">
              <button class="download-btn" (click)="downloadFile(file)">
                <i class="fas fa-download"></i>
              </button>
              <button class="delete-btn" (click)="deleteFile(file)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- No Content Message -->
    <div class="no-content" *ngIf="directories.length === 0 && files.length === 0">
      <p>No files or directories found.</p>
    </div>
  </div>
</div> 